import React from 'react';
import { styled, mq } from 'mymoria-ui';
import { Text, Button, Col, Card, Row } from 'mymoria-ui/components';
import config from 'config';
import { Section } from 'components';
import { global, form } from 'data';
import { useLocation } from 'react-router-dom';

const Flowers = styled.img`
  position: absolute;
  top: 17%;
  z-index: 50;

  ${mq({
    width: ['150px', '200px'],
    height: ['100px', '150px'],
    display: ['none', 'block'],
  })};
`;

const ButtonCol = styled(Col)`
  margin: 2rem 0;

  button {
    ${mq({
      width: ['100%', 'auto'],
    })};
  }
`;

const StyledButtonCol = styled(ButtonCol)`
  padding: 0;
`;
const StyledGhost = styled(Button)(
  mq({
    marginLeft: ['0', '2rem'],
  }),
);

const StyledCard = styled(Card)`
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin: 1rem 0 0 0 !important;
  }
`;

const Final = () => {
  const {
    state: { id = '' },
  } = useLocation<{ id: string }>();

  const handleClick = () =>
    window.open(new URL(`/pdf/poa/${id}`, config.api.endpoint).toString(), '_blank');

  return (
    <Section title={global.title}>
      <Row justifyContent="center" width={1}>
        <Col width={[1, 10 / 12, 2 / 3]}>
          <StyledCard title={form.final.title}>
            <Flowers src="/img/img_modal_flower.png" alt="flowers" />
            <Text mb="3rem">{form.final.description}</Text>
            <StyledButtonCol
              width={[1, 1, 1]}
              display="flex"
              alignItems="center"
              flexWrap={['wrap', 'nowrap']}
              flexDirection={['column', 'row']}
            >
              <Button onClick={handleClick}>{global.labels.downloadPdf}</Button>
              <a href={form.final.backToOfferUrl}>
                <StyledGhost ghost>{form.final.buttonText}</StyledGhost>
              </a>
            </StyledButtonCol>
          </StyledCard>
        </Col>
      </Row>
    </Section>
  );
};

export default Final;
